import { render } from "./editUserModal.vue?vue&type=template&id=f1132598"
import script from "./editUserModal.vue?vue&type=script&lang=js"
export * from "./editUserModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__